"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePrize = exports.getPrizes = exports.getPrizeById = exports.deletePrize = exports.defaultPrizeData = exports.createPrize = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultPrizeData = exports.defaultPrizeData = {
  id: 0,
  enabled: true,
  name: undefined,
  gameLevelId: undefined,
  rewardPoint: 0,
  quantity: 0,
  isUnlimited: false,
  description: undefined,
  images: [],
  specification: undefined,
  wishListCount: 0,
  claimedCount: 0,
  priority: 0,
  gameLevel: undefined
};
const getPrizes = params => (0, _request.default)({
  url: '/prizes',
  method: 'get',
  params
});
exports.getPrizes = getPrizes;
const getPrizeById = id => (0, _request.default)({
  url: `/prizes/${id}`,
  method: 'get'
});
exports.getPrizeById = getPrizeById;
const updatePrize = (id, data) => (0, _request.default)({
  url: `/prizes/${id}`,
  method: 'patch',
  data
});
exports.updatePrize = updatePrize;
const deletePrize = id => (0, _request.default)({
  url: `/prizes/${id}`,
  method: 'delete'
});
exports.deletePrize = deletePrize;
const createPrize = data => (0, _request.default)({
  url: '/prizes/',
  method: 'post',
  data
});
exports.createPrize = createPrize;